<template>
  <Content id="caches">
    <Row>
      <Col span="12">
        <Row :gutter="8" class="tableCell" style="margin-bottom: 10px;">
          <Col style="height:35px;line-height:35px;text-align: center;">
            <div style="font-weight: bold;margin-right: 5px;"> 设置缓存 </div>
          </Col>
        </Row>

        <Form label-position="left" :model="formSet" :label-width="70" style="width:50%;margin: 0 auto">
          <FormItem label="缓存KEY" :label-width="70">
            <Input v-model="formSet.key" type="text" style="width: 250px;"/>
          </FormItem>
          <FormItem label="哈希KEY" :label-width="70">
            <Input v-model="formSet.hashkey" type="text" style="width: 250px;"/>
          </FormItem>
          <FormItem label="缓存值" :label-width="70">
            <Input v-model="formSet.values" type="textarea" style="width: 250px;"/>
          </FormItem>
          <FormItem>
            <div style="text-align: center;"><Button type="primary" @click="set">确定</Button></div>
          </FormItem>
        </Form>
      </Col>
      <Col span="12">
        <Row :gutter="8" class="tableCell" style="margin-bottom: 10px;">
          <Col style="height:35px;line-height:35px;text-align: center;">
            <div style="font-weight: bold;margin-right: 5px;"> 删除缓存 </div>
          </Col>
        </Row>
        <Form label-position="left" :model="formDel" style="width:50%;margin: 0 auto">
          <FormItem label="缓存KEY" :label-width="70">
            <Input v-model="formDel.key" type="text" style="width: 250px;"/>
          </FormItem>
          <FormItem label="哈希KEY" :label-width="70">
            <Input v-model="formDel.hashkey" type="text" style="width: 250px;"/>
          </FormItem>
          <FormItem>
            <div style="text-align: center;"><Button type="primary" @click="submit">确定</Button></div>
          </FormItem>
        </Form>
      </Col>
    </Row>

  </Content>
</template>

<script>
import {_delete, _set} from "@/services/manage/caches"
export default {
  name: "Caches",
  data:()=>({
    formSet:{
      key:'',
      hashkey:'',
      values:''
    },
    formDel:{
      key:'',
      hashkey:'',
      values:''
    },
  }),
  created() {

  },
  mounted() {
  },
  methods:{
    set(){
      if(!this.formSet.key){
        this.$message.warning('请填写缓存Key');
        return;
      }else if(!this.formSet.values){
        this.$message.warning('请填写缓存的值');
        return;
      }

      _set(this.formSet).then(res=>{
        if (res && res.errcode == 1) {
          this.$message.success("设置成功")
        }else{
          this.$message.error(res.errmsg)
        }
      })
    },
    submit(){
     if(!this.formDel.key){
       this.$message.warning('请填写缓存Key');
       return;
     }
      _delete(this.formDel).then(res=>{
        this.$message.success("删除成功")
      })
    },
  }
}
</script>

<style scoped>

</style>
